"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleTag = exports.ProductCTA = exports.PriceRange = exports.ProductDetails = exports.ProductSummary = exports.ProductImage = exports.ModalContent = exports.ModalBase = exports.DetailModal = void 0;
/**
 * Aggregate component with most common layout
 */
var DetailModal_1 = require("./components/DetailModal");
Object.defineProperty(exports, "DetailModal", { enumerable: true, get: function () { return __importDefault(DetailModal_1).default; } });
/**
 * Modal functionality and slotting content
 */
var ModalBase_1 = require("./components/ModalBase");
Object.defineProperty(exports, "ModalBase", { enumerable: true, get: function () { return __importDefault(ModalBase_1).default; } });
var ModalContent_1 = require("./components/ModalContent");
Object.defineProperty(exports, "ModalContent", { enumerable: true, get: function () { return __importDefault(ModalContent_1).default; } });
/**
 * Components used mainly as content for the Modal
 */
var ProductImage_1 = require("./components/ProductImage");
Object.defineProperty(exports, "ProductImage", { enumerable: true, get: function () { return __importDefault(ProductImage_1).default; } });
var ProductSummary_1 = require("./components/ProductSummary");
Object.defineProperty(exports, "ProductSummary", { enumerable: true, get: function () { return __importDefault(ProductSummary_1).default; } });
var ProductDetails_1 = require("./components/ProductDetails");
Object.defineProperty(exports, "ProductDetails", { enumerable: true, get: function () { return __importDefault(ProductDetails_1).default; } });
var PriceRange_1 = require("./components/PriceRange");
Object.defineProperty(exports, "PriceRange", { enumerable: true, get: function () { return __importDefault(PriceRange_1).default; } });
var ProductCTA_1 = require("./components/ProductCTA");
Object.defineProperty(exports, "ProductCTA", { enumerable: true, get: function () { return __importDefault(ProductCTA_1).default; } });
/**
 * Utils used by the modal
 */
var handleTag_1 = require("./utils/handleTag");
Object.defineProperty(exports, "handleTag", { enumerable: true, get: function () { return __importDefault(handleTag_1).default; } });
//# sourceMappingURL=index.js.map